import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ZahtjevTable } from '../../common/types/types';

interface ZahtjeviState {
  searchDocuments: ZahtjevTable[];
}

const initialState: ZahtjeviState = {
  searchDocuments: [],
};

const searchDocumentsSlice = createSlice({
  name: 'searchDocuments',
  initialState,
  reducers: {
    reset: (state) => initialState,
    setSearchDocuments: (state, action: PayloadAction<ZahtjevTable[]>) => {
      return { ...state, searchDocuments: action.payload };
    },
  },
});

export const { reset, setSearchDocuments } = searchDocumentsSlice.actions;
export default searchDocumentsSlice.reducer;
